import React from 'react'

export default function Skills() {
    return (
        <div className="bodytext-reveal">
            <div id="skills" className="mt-16 w-24 h-2 bg-regal-blue m-auto"></div>
            <div className="m-auto flex flex-col xl:flex-row w-11/12 xl:w-8/12 mt-12">
                <div className="w-full xl:w-8/12 pr-8">
                    <div className="w-full justify-between flex">
                        <img src="images/mongodb.png" alt="mongodblogo" className="h-12 laptop:h-20 xl:h-24" />
                        <img src="images/nodejs.png" alt="mongodblogo" className="h-12 laptop:h-20 xl:h-24" />
                        <img src="images/figma.svg" alt="mongodblogo" className="h-12 laptop:h-20 xl:h-24" />
                    </div>
                    <div className="w-full mt-12 justify-between flex">
                        <img src="images/ps.png" alt="mongodblogo" className="h-16 laptop:h-20 xl:h-24" />
                        <img src="images/js.png" alt="mongodblogo" className="h-16 laptop:h-20 xl:h-24" />
                        <img src="images/ae.png" alt="mongodblogo" className="h-16 laptop:h-20 xl:h-24" />
                        <img src="images/reactjs.png" alt="mongodblogo" className="h-16 laptop:h-20 xl:h-24" />
                    </div>
                    <div className="w-full mt-12 flex">
                        <img src="images/tailwind.svg" alt="mongodblogo" className="h-16 laptop:h-20 xl:h-24" />
                        <img src="images/express.png" alt="mongodblogo" className=" ml-9 laptop:h-20 h-16 xl:h-24" />
                    </div>
                </div>
                <div className="w-full order-first xl:order-last mb-8 xl:mb-0 xl:w-4/12 items-start flex flex-col">
                    <p className="uppercase text-left tracking-wider text-4xl font-bold"><p style={{ boxShadow: "0px -20px 0px -3px rgba(49, 72, 236, 0.26) inset" }}>tools</p></p>
                    <p className="text-xl mt-2 text-left tracking-wider font-semibold">What I can and practice in commerce and portfolio</p>
                </div>
            </div>
        </div>
    )
}
